
import { useState, useEffect } from '@wordpress/element';
import { getFiltersFromURL, getPageFromURL, buildQueryParams, syncURL, getQueryFromURL} from "../helpers/urlHelpers";
import { Filters } from "./Filters";
import { Pagination } from "./Pagination";
import { Cards } from "./Cards";
import { Search } from './Search';
import { Sort } from './Sort';
// import { useRef } from 'react';
import { useRef } from '@wordpress/element';

export default function App({ initialData }) {

  const [data, setData] = useState(initialData);
  const [filters, setFilters] = useState(getFiltersFromURL());
  const [page, setPage] = useState(getPageFromURL());
  const [query, setQuery] = useState(getQueryFromURL());
  const [sortVal, setSortVal] = useState('billIntroducedTimeStamp');
  const [sortOrder, setSortOrder] = useState('desc');
  const didMount = useRef(false);

// FETCH (includes sort)
useEffect(() => {

  const params = new URLSearchParams(
    buildQueryParams(filters, page, query)
  );

  params.set('sortVal', sortVal);
  params.set('sortOrder', sortOrder);

  fetch(`/wp-admin/admin-ajax.php?action=meili_search&${params}`)
    .then(res => res.json())
    .then(json => setData(json));

}, [filters, page, query, sortVal, sortOrder]);


// SYNC URL (does NOT care about sort)
useEffect(() => {

  if (!didMount.current) {
    didMount.current = true;
    return;
  }

  syncURL(filters, page, query);

}, [filters, page, query]);



  // async function fetchData() {

  //   const params = buildQueryParams(filters, page, query);

  //   const response = await fetch(
  //     `/wp-admin/admin-ajax.php?action=meili_search&${params}`
  //   );

  //   const json = await response.json();

  //   setData(json);
  // }

  return (
    <>
      <div className="bill-filters" id='billTop'>
        <Filters
          data={data}
          filters={filters}
          setFilters={setFilters}
          setPage={setPage}
        />
      </div>
      <div className='bill-search-sort'>
        <Sort
          sortVal={sortVal}
          sortOrder={sortOrder}
          setSortVal={setSortVal}
          setSortOrder={setSortOrder}
          setPage={setPage}
        />
        <Search
          query={query}
          setQuery={setQuery}
          setPage={setPage}
          data={data}
        />
      </div>
      <div className='bill-cards-grid'>

        <Cards data={data} />

        <Pagination
          data={data}
          page={page}
          setPage={setPage}
        />
      </div>

    </>
  );
}
